<template>
<div>
    <Breadcrumbs main="Admin" submain="System" title="Coupon" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Coupon</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="coupon_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title" style="max-width: 200px;">
                                            <h7>{{ row.item.title }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(created_on)="row">
                                        <div v-if="row.item.created_on" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.created_on.split('T')[0] }}</h7>
                                            <h7>{{ row.item.created_on.split('T')[1].split('.')[0] }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(expiry_date)="row">
                                        <div v-if="row.item.expiry_date" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.expiry_date.split('T')[0] }}</h7>
                                            <h7>{{ row.item.expiry_date.split('T')[1].replace('Z', '') }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCoupon(data.item.id)" title="Delete"></feather>
                                            </div>

                                            <div @click="editCoupon(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Coupon Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Coupon" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Type</label>
                        <select class="form-control digits" v-model="coupon.coupon_type">
                            <option disabled value="">Select a type</option>
                            <option v-for="(type, index) in types" :key="index" :value="type.id">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Coupon</label>
                        <input class="form-control" type="text" placeholder="Enter coupon code" v-model="coupon.coupon_string">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter coupon title" v-model="coupon.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Usage Limit</label>
                        <input class="form-control" type="number" placeholder="Enter usage limit" v-model="coupon.usage_limit">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Discount Amount</label>
                        <input class="form-control" type="number" placeholder="Enter discount amount" v-model="coupon.discount_amount">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Expiry Date</label>
                        <input class="form-control" type="datetime-local" placeholder="Enter expire date" v-model="coupon.expiry_date">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Coupon Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Coupon" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Type</label>
                        <select class="form-control digits" v-model="edit_coupon.coupon_type">
                            <option disabled value="">Select a type</option>
                            <option v-for="(type, index) in types" :key="index" :value="type.id">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Coupon</label>
                        <input class="form-control" type="text" placeholder="Enter coupon code" v-model="edit_coupon.coupon_string">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter coupon title" v-model="edit_coupon.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Usage Limit</label>
                        <input class="form-control" type="number" placeholder="Enter usage limit" v-model="edit_coupon.usage_limit">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Discount Amount</label>
                        <input class="form-control" type="number" placeholder="Enter discount amount" v-model="edit_coupon.discount_amount">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Expiry Date</label>
                        <input class="form-control" type="datetime-local" placeholder="Enter expire date" v-model="edit_coupon.expiry_date">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Coupon Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this coupon?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'coupon_string',
                    label: 'Coupon',
                    sortable: true
                },
                {
                    key: 'coupon_type',
                    label: 'Type',
                    sortable: true
                },
                {
                    key: 'discount_amount',
                    label: 'Discount Amount',
                    sortable: true
                },
                {
                    key: 'usage_limit',
                    label: 'Usage Limit',
                    sortable: true
                },
                {
                    key: 'created_on',
                    label: 'Created On',
                    sortable: true
                },
                {
                    key: 'expiry_date',
                    label: 'Expiry Date',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            coupon: {
                title: "",
                coupon_type: "",
                coupon_string: "",
                usage_limit: "",
                discount_amount: "",
                expiry_date: ""
            },
            edit_coupon: {
                id: null,
                title: "",
                coupon_type: "",
                coupon_string: "",
                usage_limit: "",
                discount_amount: "",
                expiry_date: ""
            },
            types: [
                {
                    id: 'percentage',
                    name: 'Percentage'
                },
                {
                    id: 'fixed',
                    name: 'Fixed Amount'
                }
            ],
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            coupon_list: state => state.coupon.coupon,
            upozilas: state => state.packages.upazila,
            loading: state => state.coupon.couponLoading,
            error: state => state.coupon.couponError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("upazila/fetchUpazila")
        this.$store.dispatch("coupon/fetchCoupon").then(() => {
            this.items = this.coupon_list
            this.totalRows = this.coupon_list.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.coupon.title = ""
            this.coupon.coupon_string = ""
            this.coupon.coupon_type = ""
            this.coupon.usage_limit = ""
            this.coupon.discount_amount = ""
            this.coupon.expiry_date = ""
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("coupon/addCoupon", {
                coupon: this.coupon
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                   this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editCoupon(detail) {
            this.edit_coupon.id = detail.id ? detail.id : null
            this.edit_coupon.title = detail.title ? detail.title : null
            this.edit_coupon.coupon_string = detail.coupon_string ? detail.coupon_string : null
            this.edit_coupon.coupon_type = detail.coupon_type ? detail.coupon_type : null
            this.edit_coupon.usage_limit = detail.usage_limit ? detail.usage_limit : null
            this.edit_coupon.discount_amount = detail.discount_amount ? detail.discount_amount : null
            // this.edit_coupon.expiry_date = detail.expiry_date ? detail.expiry_date : null
            this.edit_coupon.expiry_date = detail.expiry_date ? new Date(detail.expiry_date).toISOString().slice(0, 16) : null;
        },

        resetEditModal() {
            this.edit_coupon.title = null
            this.edit_coupon.coupon_string = null
            this.edit_coupon.coupon_type = null
            this.edit_coupon.usage_limit = null
            this.edit_coupon.discount_amount = null
            this.edit_coupon.expiry_date = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("coupon/updateCoupon", {
                id: this.edit_coupon.id,
                coupon: this.edit_coupon
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteCoupon(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("coupon/deleteCoupon", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
